"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const native_base_1 = require("native-base");
const Splash = ({ spinner = false, getUIComponents, getImage, h = undefined, w = undefined, }) => {
    const UI = getUIComponents();
    return (react_1.default.createElement(native_base_1.Box, { flex: 1, pt: "70", h: h, w: w, bg: UI.background },
        react_1.default.createElement(native_base_1.Center, { p: 20 },
            react_1.default.createElement(native_base_1.Text, { color: "white", fontSize: "3xl", fontWeight: "bold", fontFamily: 'Montserrat' }, "SapporoGo"),
            react_1.default.createElement(native_base_1.Image, { alt: "SapporoGuard Logo", source: getImage('badge'), size: "lg" })),
        !!spinner && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(native_base_1.Spinner, { size: "lg", accessibilityLabel: "Loading...", color: "#FFD51C" })))));
};
exports.default = Splash;
